module.exports = __webpack_public_path__ + "img/img_level_22.d26a4c9c.png";